import React, { FunctionComponent } from "react";
import styles from "./ProductGrid.module.scss";
import ProductGridContent from "./ProductGridContent.model";

import combineClasses from "helpers/combine-classes";
import getProcessedRichtext from "blocks/helpers/getProcessedRichtext";
import getWrapperStyles from "blocks/helpers/getWrapperStyles";
import Product from "./components/Product/Product";
import Anchor from "components/Anchor/Anchor";

const ProductGrid: FunctionComponent<ProductGridContent> = (props) => {
    const processedBodyText = getProcessedRichtext(props.content.bodyText);
    const wrapperStyles = getWrapperStyles(props.settings);

    return (
        <section className={combineClasses([styles.wrapper, ...wrapperStyles])}>
            {/* Products */}
            {props.content.products && props.content.products.length > 0 ?
                <div className={styles.grid}>
                    {/* Intro */}
                    {props.content.headline || processedBodyText ?
                        <div className={styles.intro}>
                            <div className={styles.intro_inner}>
                                {/* Headline */}
                                <h3 className={styles.headline}>{props.content.headline}</h3>

                                {/* Body Text */}
                                {processedBodyText ? <div className={styles.bodyText} dangerouslySetInnerHTML={processedBodyText}></div> : null}

                                {/* Buttons */}
                                {props.content.buttons && props.content.buttons.length > 0 ?
                                    <div className={styles.buttons}>
                                        {props.content.buttons.map(button => {
                                            return (
                                                <Anchor key={button.contentUdi} to={button?.link} target={button?.target} className={styles.button}>
                                                    <span className={styles.button_label}>{button?.label}</span>
                                                </Anchor>
                                            );
                                        })}
                                    </div> : null}
                            </div>
                        </div> : null}

                    {props.content.products.map(product => {
                        return (
                            <Product key={product.contentUdi} {...product} />
                        );
                    })}
                </div> : null}
        </section>
    );
};

export default ProductGrid;